

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import "babel-polyfill"
import KHbase from './kanghe.config'
import KHweixin from './wx/weixinData'
import  './wx/wxShare'
import './appBridge'
import VConsole from 'vconsole'
Vue.config.productionTip = false

Vue.prototype.getAppUser = function(key) {

var user = sessionStorage.getItem('user') || localStorage.getItem('user')
if(user) {
try {
return JSON.parse(user)[key]
} catch (e) {
sessionStorage.removeItem("user");
localStorage.removeItem("user");
return ""
}
}
return ""
}

Vue.prototype.getAppMember = function(key) {

var member = sessionStorage.getItem('member') || localStorage.getItem('memberCode')
if(member) {
try {
return JSON.parse(member)[key]
} catch (e) {
sessionStorage.removeItem("member");
localStorage.removeItem("member");
return ""
}
}
return ""
}

function isWeiXin(){

var ua = window.navigator.userAgent.toLowerCase();

return (ua.match(/MicroMessenger/i) == 'micromessenger')
}

let openId = localStorage.getItem("openid");
if(!openId && isWeiXin()){
sessionStorage.removeItem("user");
localStorage.removeItem("openid");
}

console.log('cao6868866', process.env.BUILD_ENV);

if (process.env.BUILD_ENV !== 'production') {
new VConsole()
}

import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'

Vue.use(ToastPlugin, { isShowMask:true,time:2000 })
Vue.use(LoadingPlugin)
Vue.use(AlertPlugin)
Vue.component('group', Group)
Vue.component('cell', Cell)
Vue.component('cell-box', CellBox)

import 'common/stylus/index.styl'
import 'common/iconfont/iconfont.css'

Vue.prototype.KHbase = KHbase;

import * as calculation from '@/utils/calculation'
Vue.prototype.KHCalc = calculation;

Vue.prototype.KHweixin = KHweixin;


/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js